import { extractFilterIdsForLayer } from "../../../util/featureFilterUtil";
import { AnyAction, IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wfs3dLayersState } from "../../wfs3dLayers.reducer";

export const wfs3dFeatureFilterPartialReducer: IPartialReducer<Wfs3dLayersState> = (
    state: Wfs3dLayersState,
    action: AnyAction
) => {
    const layers = state.layers ? [...state.layers] : [];
    const newLayers = [];
    for (const layer of layers) {
        const cloned = { ...layer };
        const filteredFeatures = extractFilterIdsForLayer(
            cloned.name,
            cloned.featureShortName,
            [...cloned.features.features],
            action.filters
        );
        cloned.visible = !!filteredFeatures;
        cloned.filteredFeatures = filteredFeatures;
        cloned.changed = true;
        newLayers.push(cloned);
    }
    return {
        layers: newLayers,
        loading: true,
    };
};
